module.exports = __webpack_public_path__ + "static/img/core-bg-01.4d14285.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/core-bg-01.png
// module id = RN3L
// module chunks = 1